<template>
  <div>
    <section class="bg-white">
      <div class="flex justify-end items-center gap-2 ">
        <div class="px-2 py-2 flex items-center justify-between  silver-tier">
          <img v-if="tierTitle == 'No Tier'" src="../../../../views/3pl/BillingandCollection/icons/no-tier-icon.svg"
            alt="star">
          <img v-if="tierTitle == 'Silver'" src="../../../../views/3pl/BillingandCollection/icons/star.svg" alt="star">

          <h3>{{ tierTitle }} {{ commissionRate}} </h3>
          
          <img class="cursor-pointer" @click="openModal" src="../../../../views/3pl/BillingandCollection/icons/eye.svg"
            alt="eye">
        </div>
        <Tooltip />
      </div>



      <!-- 📌 MODAL (shows based on `currentTier`) -->
      <!-- Silver Modal -->
      <div v-if="showModal && currentTier === 'Silver'">
        <SilverTierModal :tierTitle="tierTitle" @open-work-modal="openWorkModal" @close-modal="close" />
      </div>

      <!-- Gold Modal -->
      <div v-if="showModal && currentTier === 'Gold'">
        <GoldTierModal @open-work-modal="openWorkModal" @close-modal="close" />
      </div>

      <!-- Diamond Modal -->
      <div v-if="showModal && currentTier === 'Diamond'">
        <DiamondTierModal @open-work-modal="openWorkModal" @close-modal="close" />
      </div>
      <div v-if="showWorkModal">
        <WorkModal @close-work-modal="closeWorkModal" @open-prev-modal="openPrevModal" />
      </div>
      <div>
        <!-- Loader -->
        <div v-if="loading" class="flex justify-center items-center py-10">
          <div class="loader"></div>
          <p class="ml-2">Fetching your analytics...</p>
        </div>
        <!-- <div v-else-if="isEmptyState" class="empty-overview">
          <img src="../../../../views/3pl/BillingandCollection/icons/logos_overview-emptystate.svg" alt="eye">
          <p class="text-center py-10">No analytics to show yet. As soon as you complete bookings, your analytics will
            be displayed here.</p>
        </div> -->
        <div v-else>
          <div>
            <div class="flex-wrap flex  metrics-wrap px-1 py-1">
              <div class="py-2">
                <div class="flex pl-4 metrics-wrap-cover">
                  <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/TransactionIcon.svg" alt="">
                  <div class="metrics-content">
                    <p>EARNINGS</p>
                    <h4> ₦ {{ formatAmount(Paymentdetails.totalEarning) }}</h4>
                  </div>
                </div>
              </div>

              <div class="py-2">
                <div class="flex pl-4 metrics-wrap-cover">
                  <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/Payouts.svg" alt="">
                  <div class="metrics-content">
                    <p>PAYOUTS</p>
                    <h4> ₦ {{ formatAmount(Paymentdetails.totalPayout) }}</h4>
                  </div>
                </div>
              </div>

              <div class="py-2">
                <div class="flex pl-4 metrics-wrap-cover">
                  <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/RevenueIcon.svg" alt="">
                  <div class="metrics-content">
                    <p>CURRENT BALANCE</p>
                    <h4> ₦ {{ formatAmount(Paymentdetails.totalCurrentBalance) }}</h4>
                  </div>
                </div>
              </div>

              <div class="py-2">
                <div class="flex pl-4 ">
                  <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/EarningIcon.svg" alt="">
                  <div class="metrics-content">
                    <p>TOTAL NO OF TRANSACTIONS</p>
                    <h4> {{ (Paymentdetails.totalNumberOfTransaction || 0).toLocaleString() }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="custom-filter flex justify-end mt-10 mb-8 gap-4 ">
            <div class="date-range-mobile flex items-center justify-center" v-if="interval == 'custom'">
              <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />
              <span>To</span>
              <el-date-picker class="ml-3" type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
            </div>
            <el-dropdown trigger="click" class="h-full w_semi">
              <div class="drp-content">
                <span>
                  <img src="../../../../views/3pl/BillingandCollection/icons/CalendarIcon.svg" />
                  <abbr class="vrt_line"></abbr>
                  <span class="inline-block whitespace-nowrap">{{ filterTitle }}</span>
                </span>
                <ArrowDownBlackIcon :style="{ width: '13px' }" color="black" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <button @click="setFilterType('today', 'Today')">Today</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('week', 'This week')">This week</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('month', 'This month')">This month</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('year', 'This year')">This year</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('all', 'All time')">All time</button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <button @click="setFilterType('custom', 'Custom')">Custom</button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div v-if="isEmptyState" class="empty-overview">
            <img src="../../../../views/3pl/BillingandCollection/icons/logos_overview-emptystate.svg" alt="eye">
            <p class="text-center py-10">No analytics to show yet. As soon as you complete bookings, your analytics will
              be displayed here.</p>
          </div>

          <div v-else>
            <div id="content">
              <div v-for="(chartData, index) in chartsData" :key="index"
                :class="{ 'Earnings': index === 0, 'Payouts': index === 1, 'Current-Balance': index === 2 }">
                <DonutChart :showLabels="chartData.showLabels" :fontSize="chartData.fontSize"
                  :keys="chartsData[index].id" :showTotal="chartData.showTotal" :totalLabel="chartData.totalLabel"
                  :header="chartData.header" :colors="chartData.colors" :labels="chartData.labels"
                  :series="chartData.series" />
              </div>
            </div>
            <LineChart :lineChart="lineChart" />
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>

import moment from "moment";
import ArrowDownBlackIcon from "../../../UI/svgs/ArrowDownBlackIcon.vue";
import DonutChart from "./modules/DonutChart.vue"
import LineChart from "./modules/LineChart.vue"
import debounce from "@/utilities/debounce";
import Tooltip from "./Tooltip/OverviewTip.vue";
import SilverTierModal from "./Modals/SilverTierModal.vue";
import GoldTierModal from "./Modals/GoldTierModal.vue";
import DiamondTierModal from "./Modals/DiamondTierModal.vue";
import WorkModal from "./Modals/WorkModal.vue";


export default {
  components: {
    WorkModal,
    SilverTierModal,
    GoldTierModal,
    DiamondTierModal,
    Tooltip,
    ArrowDownBlackIcon,
   LineChart,
   DonutChart
  },
  data() {
    return {
      loading: true,
      currentTier: '',
      currentTierProgress: '',
      commissionRate: '',
      showModal: false,
      showWorkModal: false,
      lineChart: [],
      allTransactions: [],
      Paymentdetails: {},
      donutChart: {},
      searchString: "",
      interval: "month",
      filterTitle: 'This Month',
      statusFilter: '',
      startDate: '',
      endDate: "",
      currentBalance: {},
      currentBalanceCost: 0,
      currentBalanceTips: 0,
      earnings: {},
      payouts: {},

      chartsData: [
        {
          series: [],
          labels: [],
          colors: [],
          header: 'Earnings',
          totalLabel: ['Total'],
          showTotal: 'Null',
          showLabels: true,
          fontSize: "14px",
          id: 0,
        },
        {
          series: [],
          labels: [],
          colors: [],
          header: 'Payouts',
          totalLabel: ['Total'],
          showTotal: '',
          showLabels: true,
          id: 1,
        },
        {
          series: [],
          labels: [],
          colors: [],
          header: 'Current Balance',
          totalLabel: ['Total'],
          showTotal: '',
          showLabels: true,
          id: 2,
        }
      ]

    };
  },

  methods: {
    async getViewTierHistory() {
      let response = await this.$_getTeirCategory({ customerType: '3PL', fleetType: "Bike" })
      if (['silver', 'gold', 'platinum', 'diamond'].includes(response.data.currentTier?.toLowerCase())) {
        this.currentTier = response.data.currentTier;
        this.currentTierProgress = response.data.progressToNextTier;
        this.commissionRate = response.data.commissionRate; 
        
      } else {
        this.currentTier = response.data.currentTier;
      }
    },
    formatAmount(number) {
      return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
    loadEarnings(val) {

      if (!val || Object.keys(val).length === 0) {
        return;
      }
      const shippingCost = val.shippingCost;
      const tips = val.tips;

      if (shippingCost == null && tips == null) {
        return;

      }
      this.chartsData[0].labels.splice(-2, 2);
      this.chartsData[0].series.splice(-2, 2);
      this.chartsData[0].colors.splice(-2, 2);
      this.chartsData[0].colors.push('#3F5F8E', '#10233E');
      this.chartsData[0].series.push(shippingCost, tips);
      this.chartsData[0].labels.push('Shipping Cost', 'Tips');
      // this.chartsData[0].labels.push(
      //   'Shipping Cost: N' + shippingCost,
      //   'Tips: N' + tips
      // );
    },
    loadpayouts(val) {
      if (!val || Object.keys(val).length === 0) {
        return;
      }
      const cashedOut = val.totalCashOut;
      const paid = val.totalPaid;

      if (cashedOut == null && paid == null) {
        return;
      }
      this.chartsData[1].labels.splice(-2, 2);
      this.chartsData[1].series.splice(-2, 2);
      this.chartsData[1].colors.splice(-2, 2);
      this.chartsData[1].colors.push('#FF6E81', '#EA3C53');
      this.chartsData[1].series.push(cashedOut, paid);
      this.chartsData[1].labels.push('Cashed Out', 'Paid');
      // this.chartsData[1].labels.push(
      //   'Cashed Out: N' + cashedOut,
      //   'Paid: N' + paid
      // );
    },
    loadCurrentBalance(val) {
      // Check if val is null or an empty object
      if (!val || Object.keys(val).length === 0) {
        return;
      }
      this.currentBalanceCost = val.shippingCost;
      this.currentBalanceTips = val.tips;
      // Optionally check if shippingCost and tips exist
      if (this.currentBalanceCost == null && this.currentBalanceTips == null) {
        return;
      }

      this.chartsData[2].labels.splice(-2, 2);
      this.chartsData[2].series.splice(-2, 2);
      this.chartsData[2].colors.splice(-2, 2);
      this.chartsData[2].colors.push('#28F3BE', '#09B78A');
      this.chartsData[2].series.push(this.currentBalanceCost, this.currentBalanceTips);
      this.chartsData[2].labels.push('Shipping Cost', 'Tips');
      // this.chartsData[2].labels.push(
      //   'Shipping Cost: N' + this.currentBalanceCost,
      //   'Tips: N' + this.currentBalanceTips
      // );

    },

    setFilterType(val, title) {
      this.interval = null
      this.interval = val
      this.filterTitle = title
      if (this.interval != "custom") {
        this.getAllEarnAndPay();
        this.startDate = ""
        this.endDate = ""
      }
    },
    async getAllEarnAndPay() {
      this.loading = true;
      try {
        let response = await this.$_getEarningsAndPayouts(this.earnPayload);
        this.Paymentdetails = response.data.data;
        this.lineChart = this.Paymentdetails.earningLineGraph
        this.loadCurrentBalance(this.Paymentdetails.currentBalanceChart);
        this.loadEarnings(this.Paymentdetails.earningChart);
        this.loadpayouts(this.Paymentdetails.payoutChart);
      } catch (error) {
        this.generateToast(
          error.response?.data?.data?.message || "Something went wrong",
          "error"
        );
      } finally {
        this.loading = false; // ✅ hide loader
      }
    },

    openModal() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
    openWorkModal() {
      this.showWorkModal = true;
      this.close();
    },
    openPrevModal() {
      this.showWorkModal = false;
      this.showModal = true;
    },
    closeWorkModal() {
      this.showWorkModal = false;
    }
  },

  computed: {
    isEmptyState() {
      const d = this.Paymentdetails;
      if (!d || Object.keys(d).length === 0) return true;

      const values = [
        d.totalNumberOfTransaction,
        d.totalEarning,
        d.totalPayout,
        d.totalCurrentBalance,
        d.currentBalanceChart?.shippingCost,
        d.currentBalanceChart?.tips,
        d.earningChart?.shippingCost,
        d.earningChart?.tips,
        d.payoutChart?.totalCashOut,
        d.payoutChart?.totalPaid,
        ...(d.earningLineGraph || []).map(e => e.earning)
      ];

      return values.every(v => !v || v === 0); // true if all values are 0 or falsy
    },
    tierTitle() {
      switch (this.currentTier) {
        case 'Silver':
          return 'Silver';
        case 'No Tier':
          return 'No Tier';
        case 'Gold':
          return 'Gold';
        case 'Platinum':
          return 'Platinum';
        case 'Diamond':
          return 'Diamond';
        default:
          return 'No Tier';
      }
    },
    tierPercentage() {
      switch (this.currentTier) {
        case 'Silver':
          return '15%';
        case 'gold':
          return '25%';
        case 'platinum':
          return '35%';
        case 'diamond':
          return '45%';
        case 'No Tier':
          return '';
        default:
          return '';
      }
    },
    earnPayload() {
      return {
        customerType: '3PL',
        interval: this.sortProps.interval,
        startDate: "",
        endDate: ""
      }
    },
    sortProps() {
      return {
        interval: this.interval,
        startDate: this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      };
    },
  },
  mounted() {
    this.getAllEarnAndPay()
    this.getViewTierHistory()
  },
  watch: {
    "sortProps": debounce(function () {
      if (this.interval == 'custom' && this.startDate && this.endDate && (this.endDate > this.startDate)) {
        this.earnPayload.startDate = this.sortProps.startDate;
        this.earnPayload.endDate = this.sortProps.endDate
        this.getAllEarnAndPay();
      }
    }, 500),
  },
}
</script>

<style lang="scss" scoped>
.loader {
  border: 4px solid #f3f3f3;      /* Light grey */
  border-top: 4px solid #3F5F8E;  /* Primary color */
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.empty-overview {
  background-color: #F2F7FC;
  padding-top: 5%;
}

.empty-overview>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 600;
}

.empty-overview>img {
  margin: 0 auto;
}

.container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  position: relative;
}


section {
  padding-left: 2%;
  padding-right: 2%;
  padding-bottom: 2%;
}

.silver-tier {
  width: 22%;
  border-radius: 100px;
  box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
  margin-top: 4%;
  margin-bottom: 4%;
  gap: 8px;
  border: 1px solid #ccc;
}

.silver-tier>h3 {
  font-weight: 400;
  font-size: 14px;
  color: #A5ADB7;
}

.metrics-wrap {
  border: 1px dashed #878E99;
}

.metrics-wrap>div {
  width: 25%;
  align-items: center;
  background: #FAFBFF;

}

.metrics-wrap>:nth-child(1) {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.metrics-wrap>:nth-child(4) {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.metrics-wrap-cover {
  border-right: 1px dashed #4142455C;
}

.metrics-content>p {
  color: #7A90A7;
  font-weight: 700;
  font-size: 12px;
}

.metrics-content>h4 {
  color: #383F51;
  font-weight: 600;
  font-size: 16px;
}

.w_semi {
  @apply w-[200px] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}

//@media screen and (min-width: 1100px) {
@media screen and (min-width: 1100px) {
  #content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    width: 97%;
    grid-template-areas:
      "ES PS "
      "CB CB";
  }
}

#content>* {
  border: 2px solid transparent;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 2px #00000014;
  margin: 0;
}

.Earnings {
  grid-area: ES;
}

.Payouts {
  grid-area: PS;
}

#content .Current-Balance {
  grid-area: CB;
  width: 50%;
  margin: 0 auto;
}

@media (max-width: 1099px) {
  #content .Current-Balance {
  width: 100%;
  margin: 0 ;
}
  
  .silver-tier {
    width: 30%;
  }

  #content>div {
    margin-bottom: 30px;
  }

  .metrics-wrap>:nth-child(1),
  .metrics-wrap>:nth-child(2) {
    margin-bottom: 2%;
  }

  .metrics-wrap>div {
    width: 50%;

  }

  .metrics-wrap>:nth-child(3) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .metrics-wrap>:nth-child(2) {

    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;

    .metrics-wrap-cover {
      border-right: none;
    }
  }
}

@media (max-width: 640px) {
  .metrics-wrap>div {
    width: 100%;
  }

  .metrics-wrap>:nth-child(1),
  .metrics-wrap>:nth-child(2),
  .metrics-wrap>:nth-child(3) {
    margin-bottom: 4%;
  }

  .metrics-wrap>:nth-child(2),
  .metrics-wrap>:nth-child(4) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .metrics-wrap>:nth-child(1),
  .metrics-wrap>:nth-child(3) {

    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;

    .metrics-wrap-cover {
      border-right: none;
    }
  }

  .silver-tier {
    width: 45%;
  }


}

@media (max-width: 430px) {
  .silver-tier {
    width: 55%;
  }

  .custom-filter {
    display: block;
  }

  .w_semi {
    width: 100%;
  }

  .custom-filter>.w_semi {
    padding-left: 40%;
  }

  .date-range-mobile {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
